import { Button, Checkbox, Input, Modal, notification} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { exportInspectionDetections, toggleInspectionDetectionsExport } from "redux/actions";

const detectionsExportOpenSelector = state => state.railInspection.detectionsExportOpen;
const detectionsTypeFiltersSelector = (state) => state.railInspection.detections.typeFilters;
const detectionReviewFiltersSelector = (state) => state.railInspection.detections.reviewFilters;
const userEmailSelector = state => state.userDetails.email;
const sessionIDSelector = state => state.playlist.data.routeID;

const DetectionsExportModal = () => {

    const detectionsExportOpen = useSelector(detectionsExportOpenSelector);
    const detectionsTypeFilters = useSelector(detectionsTypeFiltersSelector);
    const detectionReviewFilters = useSelector(detectionReviewFiltersSelector);
    const userEmail = useSelector(userEmailSelector);
    const sessionID = useSelector(sessionIDSelector);

    const dispatch = useDispatch();

    const [exportName, setExportName] = useState("");
    const [exportRecipient, setExportRecipient] = useState("");
    const [includeImages, setIncludeImages] = useState(true);

    const onClose = () => {
        setExportName("");
        setIncludeImages(true);
        setExportRecipient(userEmail);
        dispatch(toggleInspectionDetectionsExport())
    }

    useEffect(() => {
        if(userEmail){
            setExportRecipient(userEmail);
        }
    }, [userEmail])

    const createExport = () => {
        console.log("debug creating exports");

        const detectionFilters = {
            reviewFilters: detectionReviewFilters,
            typeFilters: detectionsTypeFilters,
            includeImages,
        }
        console.log("debug handling download here", detectionFilters);

        const exportPayload = {
            export_name: exportName,
            filters: detectionFilters,
            recipient: exportRecipient,
            session_id: sessionID
        }
        dispatch(exportInspectionDetections(exportPayload))
            .then(success => {
                if(success){
                    notification.success({
                        message: 'Successfully triggered export',
                    })
                }else{
                    notification.error({
                        message: 'Error triggering export',
                    })   
                }
                onClose();
            })
    }

    return (
        <Modal
            className="RailInsectionFilterModal"
            title="Rail Inspection Detections Export"
            visible={detectionsExportOpen}
            onOk={() => {
                createExport()
            }}
            onCancel={() => {
                onClose()
            }}
            footer={[
                <Button onClick={() => {
                    onClose()
                }}>
                    Close
                </Button>,
                <Button type="primary" onClick={() => {
                    createExport()
                }}>
                    Create Export
                </Button> 
            ]}>
            <div className="InspectionDetectionsModal">
                <div className="Row">
                    <span>
                        Export Name
                    </span>
                    <Input
                        value={exportName}
                        onChange={e => {
                            setExportName(e.target.value);
                        }} />
                </div>

                <div className="Row">
                    <span>
                        Export Recipient
                    </span>
                    <Input 
                        value={exportRecipient}
                        onChange={e => {
                            setExportName(e.target.value);
                        }} />
                </div>

                <div className="Row">
                    <span>
                        <Checkbox checked={includeImages} onChange={e => setIncludeImages(e.target.checked)}>
                            Include images
                        </Checkbox>
                    </span>
                </div>
            </div>
        </Modal>
    )
}

export default DetectionsExportModal;